import { createAction } from 'redux-actions';
export const SET_REFUND_INFO = 'REFUND/SET_REFUND_INFO ';
export const setRefundInfo = createAction(SET_REFUND_INFO);
